/**
 * Colour roles for the Cute objects world ("Kitchen & bedroom", ART-BIBLE §5.3: peach wall, cupboard
 * coral, mint tiles, strawberry red, cream, mint). Storybook (A) values are hand-picked; Sticker (B)
 * and Pastel (C) are derived by `rolePalette`. Every role is prefixed `cute` (names are global).
 */
import { rolePalette } from '../../art/palette';

export const CUTE_PALETTE = rolePalette({
  // shared bits
  cuteCherry: '#E5596A',
  cuteStem: '#6F8F4A',
  cuteSprinkleA: '#5AAFD9',
  cuteSprinkleB: '#F2C14E',
  cuteSprinkleC: '#7DB86A',
  cuteSprinkleD: '#FFFDF8',
  // cupcake
  cuteWrapper: '#8ED0C4',
  cuteWrapperDark: '#5FAA9E',
  cuteFrosting: '#F7B3C4',
  // donut
  cuteDough: '#E7AE6C',
  cuteDoughDark: '#B97C45',
  cuteIcing: '#F08DAE',
  // ice cream
  cuteCone: '#EBB873',
  cuteConeDark: '#C08A4C',
  cuteScoopMint: '#A9DEC9',
  cuteScoopPink: '#F6AFC0',
  // teacup
  cuteCup: '#FFF6EC',
  cuteCupBand: '#9AD3BF',
  cuteTea: '#C98E5E',
  cuteSaucer: '#F3C9BC',
  cuteSteam: '#E9DCD2',
  // strawberry
  cuteBerry: '#E5596A',
  cuteSeed: '#FBE3A0',
  cuteCalyx: '#6FB25E',
  // toast
  cuteCrust: '#C98E5E',
  cuteBread: '#F7DDB0',
  cuteCrumb: '#D9AA74',
  cuteButter: '#FBE38A',
  // gift box
  cuteGiftLeft: '#8ED0C4',
  cuteGiftRight: '#62AFA3',
  cuteGiftTop: '#B9E5DB',
  cuteRibbon: '#E5596A',
  cuteRibbonDark: '#BF4252',
  // backpack
  cuteBag: '#F0896F',
  cuteBagDark: '#C9604F',
  cuteBagPocket: '#F7B49C',
  cuteZip: '#F2C14E',
  // doodles
  cuteHeart: '#F27E8E',
  cuteHeartDot: '#FBC2CB',
  cutePumpkin: '#EE9440',
  cutePumpkinSide: '#DD7B30',

  // teapot (Nana Rosehip)
  cuteTeapot: '#F3C2BC',
  cuteTeapotDeep: '#D9918C',
  cuteGold: '#E9C46A',
  cuteSpecs: '#B98A5E',
  // pancake tower (Flip)
  cutePancake: '#F0C383',
  cutePancakeEdge: '#C88B4C',
  cuteHoney: '#F3B13C',
  cuteBlueberry: '#6474B8',
  cutePlate: '#FBF4EA',
  // teddy (Benny)
  cuteTeddy: '#C99462',
  cuteTeddyLight: '#EDCDA2',
  cuteTeddyDark: '#93653F',
  cutePillow: '#BBD8EE',
  cutePillowStripe: '#F5B7C5',
  // cookie (Crumbs), firefly jar (Lumi), macaron (Maca)
  cuteCookie: '#DFA868',
  cuteChoc: '#6E4636',
  cuteGlass: '#DDF0F1',
  cuteGlassDeep: '#A9D3D8',
  cuteJarLid: '#E3A55B',
  cuteFirefly: '#F7DF6E',
  cuteGlow: '#FFF2B5',
  cuteMacPink: '#F4AFC2',
  cuteMacMint: '#A9DCC9',
  cuteMacCream: '#FFF3E0',
  // remix cards
  cuteCandle: '#BFDDF2',
  cuteFlame: '#F6B24A',
  cuteFlameCore: '#FFF0A8',
  cuteLilac: '#B8A3E0',
  cuteStick: '#E8C995',
  cuteScoopChoc: '#A0705A',
  cuteEgg: '#FFFDF5',
  cuteYolk: '#F5B53A',
  cuteJam: '#D84A5E',
  cuteButterDeep: '#E7C44F',
  cuteTutu: '#FFEFF3',
  cuteBerryFlesh: '#F8C6C4',
  cuteBerryCore: '#FFF0EC',
  cuteNightcap: '#8F9BD8',
  cuteSpring: '#C6C6D2',
  cuteHatBox: '#F2B0C0',
  cuteHatBoxDeep: '#D88A9E',
  cuteFrog: '#8FCB74',
  cuteFrogDark: '#67A855',
  cuteBlanketRoll: '#7EA8D8',
  cuteFlag: '#F6D36B',
  // rooms (scenes + pictures)
  cuteWall: '#F8DECB',
  cuteWallHigh: '#F0CDB5',
  cuteWallSide: '#EBC6AE',
  cuteWallNight: '#B9A9D2',
  cuteWallNightHigh: '#9C8BC0',
  cuteWallNightSide: '#A796C4',
  cuteFloor: '#DCAB78',
  cuteFloorNear: '#C79262',
  cuteFloorNight: '#A2806F',
  cuteFloorNightNear: '#8A6A5D',
  cuteTile: '#C2E4D7',
  cuteTileLine: '#9CCDBB',
  cuteMoonlight: '#E9E5F7',
  cuteLampGlow: '#FFE7A6',
  cuteRug: '#F2A9A0',
  cuteRugDeep: '#DF8A82',
  cuteQuiltA: '#F7C7B5',
  cuteQuiltB: '#BFE0D2',
  cuteQuiltC: '#F8E3A6',
  cuteBedWood: '#C48A5E',
  cuteSheet: '#FFF8EE',
  cuteCheck: '#9FC3E6',
  cuteMouse: '#C9C1BE',
  cuteSock: '#F4A6B6',
  cuteSockStripe: '#FFF6EC',
});
